export const MAX_INSTRUMENT_COUNT = 14;
